import axios, { type AxiosError } from "axios";
import { getCookie } from "@/lib/utils";

export const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const unsafe = ["post", "put", "patch", "delete"];
  if (config.method && unsafe.includes(config.method.toLowerCase())) {
    const token = getCookie("XSRF-TOKEN");
    if (token) {
      config.headers.set("X-XSRF-TOKEN", token);
    }
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError<ApiError>) => {
    const code = err?.response?.data?.code;
    if (err?.response?.status === 401 && code === "TOKEN_EXPIRED") {
      window.dispatchEvent(new CustomEvent("auth:token-expired"));
    }
    return Promise.reject(err);
  },
);

let csrfPrimed = false;

export async function primeCsrf(): Promise<void> {
  if (csrfPrimed) return;
  await api.get("/auth/csrf");
  csrfPrimed = true;
}

export interface ApiError {
  code: string;
  message: string;
  details?: unknown;
}

export function asApiError(err: unknown): ApiError {
  const axErr = err as AxiosError<ApiError>;
  if (axErr?.response?.data?.code) {
    return axErr.response.data;
  }
  return { code: "UNKNOWN", message: axErr?.message ?? "Unknown error" };
}
